const siteCode = process.env.GATSBY_SITE_CODE || 'fi'

const siteConfig = {
  sl: {
    siteName: 'Shelf Life',
    pagesFolder: 'pages-sl',
    theme: 'theme-sl',
    url: 'https://shelflife.co',
    careersPage: {
      title: 'Careers',
      path: 'careers',
      email: 'jobs@shelflife.co'
    }
  },
  fi: {
    siteName: 'Field',
    pagesFolder: 'pages-fi',
    theme: 'theme-fi',
    url: 'https://field.inc',
    careersPage: {
      title: 'Team',
      path: 'team',
      email: 'jobs@field.inc'
    },
    newsPage: {
      title: 'News',
      path: 'news'
    }
  },
  fs: {
    siteName: 'Field Supply',
    pagesFolder: 'pages-fs',
    theme: 'theme-fs',
    url: 'https://field.supply',
    careersPage: {
      title: 'Careers',
      path: 'careers',
      email: 'jobs@field.inc'
    }
  }
}

module.exports = {
  siteCode: siteCode,
  siteConfig: siteConfig
}
